// 第二迭代商品管理
import axios from '@/libs/api.request'
import urlObj from '@/config/env.js'

// 全局设置
export function setsituation(params) {
  return axios.request({
    url: urlObj.wss + 'wss-part/parts/sellOut',
    method: 'put',
    params
  })
}
// 查询全局设置
export function getquerytion(params) {
  return axios.request({
    url: urlObj.wss + 'wss-part/parts/getSellOut',
    method: 'get',
    params
  })
}

// err新增商品
export function getinit(data) {
  return axios.request({
    url: urlObj.wss + 'wss-part/importer/erp/init',
    method: 'post',
    data
  })
}
// 下面是尚亚丹写的
// 商品列表页面
export function listGoods(data) {
  return axios.request({
    url: urlObj.wss + 'wss-part/parts/listGoods',
    method: 'post',
    data
  })
}
// 价格回显
export function getPartsPrice(params) {
  return axios.request({
    url: urlObj.wss + 'wss-part/parts/price/getPartsPrice',
    method: 'get',
    params
  })
}
// 价格编辑
export function savePartsPrice(data) {
  return axios.request({
    url: urlObj.wss + 'wss-part/parts/price/savePartsPrice',
    method: 'post',
    data
  })
}

// 新增页面选择（保存）
// 保存新增配件
export function partSave(data) {
  return axios.request({
    url: urlObj.wss + 'wss-part/parts/partSave',
    // url: 'https://tsapi2.g-parts.cn/gpart-part-provider/parts/findPart',
    method: 'post',
    data
  })
}
// 设置库存
export function setStock(params) {
  return axios.request({
    url: urlObj.wss + 'wss-part/parts/setStock',
    // url: 'https://tsapi2.g-parts.cn/gpart-part-provider/parts/findPart',
    method: 'put',
    params
  })
}
// 编辑商品页面
// 获取配件列表
export function getGoodsMassage(params) {
  return axios.request({
    url: urlObj.wss + 'wss-part/parts/getPartById',
    method: 'get',
    params
  })
}

// 查询车型
export function getcarType(data) {
  return axios.request({
    url: urlObj.wss + 'wss-part/partsBatch/getCarModelNew',
    method: 'post',
    data
  })
}
// 查询关联链
export function listRelationByPartId(params) {
  return axios.request({
    // url: urlObj.wss + 'wss-part/parts/findAllParts',
    url: urlObj.wss + 'wss-part/parts/listRelationByPartId',
    method: 'get',
    params
  })
}
// 查询替换链
export function listReplaceByPartId(params) {
  return axios.request({
    // url: urlObj.wss + 'wss-part/parts/findAllParts',
    url: urlObj.wss + 'wss-part/parts/listReplaceByPartId',
    method: 'get',
    params
  })
}
// 查询维护日志
export function getPartLogById(params) {
  return axios.request({
    // url: urlObj.wss + 'wss-part/parts/findAllParts',
    url: urlObj.wss + 'wss-part/parts/getPartLogById',
    method: 'get',
    params
  })
}
